export enum FaxRuleDirection {
  To = "To",
  From = "From",
}
